import Select, { components } from 'react-select'
import { selectStyles } from './selectStyles'

const Option = props => {
  const { data } = props
  return (
    <components.Option {...props}>
      {data.name} <span>({data.code})</span>
    </components.Option>
  )
}

const SingleValue = props => {
  const { data } = props
  return <components.SingleValue {...props}>{data.code}</components.SingleValue>
}

export const SelectComponent = ({ options, value, action, ...props }) => {
  const handleChange = val => {
    action(val)
  }

  return (
    <Select
      options={options}
      onChange={handleChange}
      getOptionLabel={option => option.name}
      getOptionValue={option => option.code}
      value={value}
      isSearchable
      styles={selectStyles}
      components={{ Option, SingleValue }}
      {...props}
    />
  )
}

export default SelectComponent
